import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { tg, haptic } from "../lib/telegram";

interface Props {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  /** Большая иконка/эмодзи слева от заголовка (как у AI Office) */
  icon?: string;
  iconColor?: "blue" | "purple" | "green" | "orange" | "pink" | "teal" | "indigo" | "yellow" | "red" | "mint" | "brown";
}

const iconColorClasses: Record<NonNullable<Props["iconColor"]>, string> = {
  blue: "bg-[var(--icon-blue-bg)] text-[var(--icon-blue)]",
  purple: "bg-[var(--icon-purple-bg)] text-[var(--icon-purple)]",
  green: "bg-[var(--icon-green-bg)] text-[var(--icon-green)]",
  orange: "bg-[var(--icon-orange-bg)] text-[var(--icon-orange)]",
  pink: "bg-[var(--icon-pink-bg)] text-[var(--icon-pink)]",
  teal: "bg-[var(--icon-teal-bg)] text-[var(--icon-teal)]",
  indigo: "bg-[var(--icon-indigo-bg)] text-[var(--icon-indigo)]",
  yellow: "bg-[var(--icon-yellow-bg)] text-[var(--icon-yellow)]",
  red: "bg-[var(--icon-red-bg)] text-[var(--icon-red)]",
  mint: "bg-[var(--icon-mint-bg)] text-[var(--icon-mint)]",
  brown: "bg-[var(--icon-brown-bg)] text-[var(--icon-brown)]",
};

export function PageHeader({ eyebrow, title, subtitle, icon, iconColor = "blue" }: Props) {
  const navigate = useNavigate();

  useEffect(() => {
    const app = tg();
    if (!app?.BackButton) return;
    const handler = () => {
      haptic("light");
      navigate(-1);
    };
    app.BackButton.show();
    app.BackButton.onClick(handler);
    return () => {
      app.BackButton.offClick(handler);
      app.BackButton.hide();
    };
  }, [navigate]);

  return (
    <div className="px-5 pt-6 pb-2">
      {icon && (
        <div className={`icon-tile icon-tile-lg mb-3 ${iconColorClasses[iconColor]}`}>{icon}</div>
      )}
      {eyebrow && (
        <div className="text-xs font-semibold uppercase tracking-widest text-muted mb-1">
          {eyebrow}
        </div>
      )}
      <h1 className="text-[28px] leading-tight font-bold text-ink tracking-tight">{title}</h1>
      {subtitle && <p className="text-muted mt-2 text-[15px] leading-snug">{subtitle}</p>}
    </div>
  );
}
